import { css } from 'lit';

import * as commonStyles from '@ahoy/ui/common/styles/common-styles.js';
export const noBillingStampStyles = css`
/** Customize stamp */
.position-relative {
 position: relative;
}

.customized-package-stamp {
 position: absolute;
 z-index: 5;      
 top: 2rem;      
 font-size: 2rem;
 background: #744bda;
 padding: 0 1rem;
 border-radius: 1rem;
 border: 1px black solid;
 color: white;
}    

.customized-package-stamp.align-left {
 left: -3rem;
 transform: rotate(-45deg);
 background: green;
}
.customized-package-stamp.align-right {
 right: -3rem;
 transform: rotate(45deg);
 background: red;
}
`;
export const noBillingStampStylesMTA = css`
.customized-package-stamp {
 line-height: 1.5;     
  top: -1rem;
 }  
 .customized-package-stamp.align-left {
  left: -4rem;
}
 .customized-package-stamp.align-right {
  right: -5rem;
}
`;
export const noBillingStampStylesMobile = css`
.customized-package-stamp { 
  top: 7rem; 
}
.customized-package-stamp.align-right {
  right: -1rem;
}
.customized-package-stamp.align-left {
  left: 7rem;
}
`;
export const commonPopupStyle = commonStyles.commonPopupStyle(css);
export const commonPopupMobileStyle = commonStyles.commonPopupMobileStyle(css);
export const commonLHCOmponentStyle = commonStyles.commonLHCOmponentStyle(css);
export const commonFormStyles = commonStyles.commonFormStyles(css);
export const commonFormDesktopStyles = commonStyles.commonFormDesktopStyles(css);
export const commonAnimationsStyle = commonStyles.commonAnimationsStyle(css);
export const commonBillingStyle = commonStyles.commonBillingStyle(css);
export const commonBillingDesktopStyle = commonStyles.commonBillingDesktopStyle(css);
export const commonBillingMobileStyle = commonStyles.commonBillingMobileStyle(css);
export const commonExternalAgentMailsDesktopStyle = commonStyles.commonExternalAgentMailsDesktopStyle(css);
